import type { Language } from '../i18n';
import { useTranslation } from '../hooks/useTranslation';

interface ComingSoonProps {
  language: Language;
  title?: string;
  message?: string;
  icon?: string;
}

const ComingSoon = ({ 
  title,
  message,
  icon = '🚧'
}: ComingSoonProps) => {
  const { t } = useTranslation();
  
  return (
    <div className="bg-tg-secondary rounded-xl p-8 text-center border border-gray-800">
      <div className="text-4xl mb-4">{icon}</div>
      <h3 className="text-xl font-semibold text-white mb-2">
        {title || `🚧 ${t('checkIn.comingSoon')}`}
      </h3>
      <p className="text-tg-hint">
        {message || t('common.loading')}
      </p>
    </div>
  );
};

export default ComingSoon;

